<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ modalTitle }}</h4>
    </div>
    <div class="modal-body">
      <div class="row" v-if="isProduct">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ _('Product') }}</label>
            <p class="form-control-static">{{ productLabel }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group languageversioned">
            <label for="footerLinkName">{{ _('Name in footer navigation') }}</label>
            <input
              id="footerLinkName"
              type="text"
              class="form-control"
              v-model="name"
              :placeholder="namePlaceholder"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="visible" />
              {{ _('Show in footer') }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="save"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    link: {
      type: Object,
      default: null
    },
    locale: {
      type: String,
      default: 'en_US'
    },
    productName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      name: '',
      names: {},
      visible: true
    }
  },
  watch: {
    link: {
      immediate: true,
      handler (link) {
        this.applyLink(link)
      }
    },
    locale (locale, previous) {
      if (previous) {
        const trimmed = (this.name || '').trim()
        if (trimmed) {
          this.names[previous] = trimmed
        } else {
          delete this.names[previous]
        }
      }
      this.name = (this.names && this.names[locale]) || ''
    }
  },
  computed: {
    isProduct () {
      return this.link && this.link.type === 'product'
    },
    productLabel () {
      if (!this.link) {
        return ''
      }
      const id = this.link.product_id
      const name = this.productName || ''
      return name ? (id + ': ' + name) : String(id || '')
    },
    modalTitle () {
      if (this.isProduct) {
        return this._('Footer link')
      }
      return this.builtinTitle
    },
    builtinTitle () {
      if (!this.link || this.link.type !== 'builtin') {
        return this._('Footer link')
      }
      switch (this.link.key) {
        case 'deliveryTerms':
          return this._('Order and cancellation terms')
        case 'privacyPolicy':
          return this._('Privacy policy')
        case 'accessibilityStatement':
          return this._('Accessibility statement')
        case 'cookies':
          return this._('Cookies')
        default:
          return this.link.key || this._('Footer link')
      }
    },
    namePlaceholder () {
      if (this.isProduct) {
        return this.productName || this._('Product name')
      }
      return this.builtinTitle
    }
  },
  methods: {
    applyLink (link) {
      const raw = link && link.names
      let names = raw
      if (typeof names === 'string') {
        try {
          names = JSON.parse(names)
        } catch (e) {
          names = null
        }
      }
      const copy = {}
      if (names && typeof names === 'object' && !Array.isArray(names)) {
        Object.keys(names).forEach(locale => {
          if (names[locale] != null && String(names[locale]).trim() !== '') {
            copy[locale] = String(names[locale])
          }
        })
      }
      this.names = copy
      this.name = copy[this.locale] || ''
      this.visible = link ? link.visible !== false : true
    },
    hideModal () {
      this.$emit('close')
    },
    save () {
      const names = { ...this.names }
      const trimmed = (this.name || '').trim()
      if (trimmed) {
        names[this.locale] = trimmed
      } else {
        delete names[this.locale]
      }
      this.$emit('save', {
        visible: !!this.visible,
        names
      })
      this.hideModal()
    }
  }
}
</script>
